export class EntryError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
  }
}
export async function entryApi<T>(path: string, method = 'GET', body?: unknown): Promise<T> {
  let response: Response;
  try {
    response = await fetch(path, {
      method,
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'content-type': 'application/json' },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
  } catch {
    throw new EntryError(
      'Connection lost. Check your connection, then retry or refresh status.',
      0,
    );
  }
  if (response.status === 204) return undefined as T;
  const data = (await response.json().catch(() => null)) as { message?: string } | null;
  if (!response.ok || !data)
    throw new EntryError(
      data?.message ?? 'Entry service unavailable. Try again shortly.',
      response.status,
    );
  return data as T;
}
export const entryMessage = (error: unknown) =>
  error instanceof Error ? error.message : 'Entry service unavailable.';
